import {Box, Typography} from '@mui/material';
import ArrTextField from '../../../components/common/arr-text-field/ArrTextField';

const TextField: React.FC = () => {
  return (
    <Box className="textfield-demo">
      <Typography className="typo-text headline1_size">ARR TextBox</Typography>
      <Box>
        <div style={{display: 'grid', gap: '2rem', padding: '2rem'}}>
          {/* Enabled States */}
          <section>
            <Typography className="typo-text headline3_size">
              Enabled (Large)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="enabled-default"
                state="enabled"
                label="Label"
                dataTestId="text-field-default"
              />
              <ArrTextField
                id="enabled-hover"
                state="enabled"
                label="Label"
                value="Input"
                placeholder="Placeholder"
                dataTestId="text-field-hover"
              />
              <ArrTextField
                id="enabled-focus"
                state="enabled"
                label="Label"
                placeholder="Placeholder"
                supportText="Support text"
                dataTestId="text-field-focus"
              />
            </div>
          </section>

          {/* Enabled States Medium */}
          <section>
            <Typography className="typo-text headline3_size">
              Enabled (Medium)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="enabled-default-medium"
                state="enabled"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-default-medium"
              />
              <ArrTextField
                id="enabled-hover-medium"
                state="enabled"
                value="Input"
                placeholder="Placeholder"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-hover-medium"
              />
              <ArrTextField
                id="enabled-focus-medium"
                state="enabled"
                placeholder="Placeholder"
                supportText="Support text"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-focus-medium"
              />
            </div>
          </section>

          {/* Enabled States Small */}
          <section>
            <Typography className="typo-text headline3_size">
              Enabled (Small)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="enabled-default-small"
                state="enabled"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-default-small"
              />
              <ArrTextField
                id="enabled-hover-small"
                state="enabled"
                value="Input"
                placeholder="Enter text"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-hover-small"
              />
              <ArrTextField
                id="enabled-focus-small"
                state="enabled"
                placeholder="Placeholder"
                supportText="Support text"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-focus-small"
              />
            </div>
          </section>

          {/* Error States */}
          <section>
            <Typography className="typo-text headline3_size">
              Error (Large)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="error-default"
                state="error"
                label="Label"
                dataTestId="text-field-error-default"
              />
              <ArrTextField
                id="error-hover"
                state="error"
                label="Label"
                value="Input"
                placeholder="Placeholder"
                dataTestId="text-field-error-hover"
              />
              <ArrTextField
                id="error-focus"
                state="error"
                label="Label"
                placeholder="Placeholder"
                supportText="Support text"
                showErrorIcon
                dataTestId="text-field-error-focus"
              />
            </div>
          </section>

          {/* Error States Medium*/}
          <section>
            <Typography className="typo-text headline3_size">
              Error (Medium)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="error-default-medium"
                state="error"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-error-default-medium"
              />
              <ArrTextField
                id="error-hover-medium"
                state="error"
                value="Input"
                placeholder="Placeholder"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-error-hover-medium"
              />
              <ArrTextField
                id="error-focus-medium"
                state="error"
                placeholder="Placeholder"
                supportText="Support text"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                showErrorIcon
                dataTestId="text-field-error-focus-medium"
              />
            </div>
          </section>

          {/* Error States small*/}
          <section>
            <Typography className="typo-text headline3_size">
              Error (Small)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="error-default-small"
                state="error"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-error-default-small"
              />
              <ArrTextField
                id="error-hover-small"
                state="error"
                value="Input"
                placeholder="Placeholder"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-error-hovert-small"
              />
              <ArrTextField
                id="error-focus-small"
                state="error"
                placeholder="Placeholder"
                supportText="Support text"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                showErrorIcon
                dataTestId="text-field-error-focus-small"
              />
            </div>
          </section>

          {/* Inactive States */}
          <section>
            <Typography className="typo-text headline3_size">
              Inactive (Disabled) (Large)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="inactive-default"
                state="inactive"
                label="Label"
                dataTestId="text-field-inactive-default"
              />
              <ArrTextField
                id="inactive-hover"
                state="inactive"
                label="Label"
                value="Input"
                placeholder="Placeholder"
                dataTestId="text-field-inactive-hover"
              />
              <ArrTextField
                id="inactive-focus"
                state="inactive"
                label="Label"
                placeholder="Placeholder"
                supportText="Support text"
                dataTestId="text-field-inactive-focus"
              />
            </div>
          </section>

          {/* Inactive States Medium */}
          <section>
            <Typography className="typo-text headline3_size">
              Inactive (Disabled) (Medium)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="inactive-default-medium"
                state="inactive"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-inactive-default-medium"
              />
              <ArrTextField
                id="inactive-hover-medium"
                state="inactive"
                value="Input"
                placeholder="Placeholder"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-inactive-hover-medium"
              />
              <ArrTextField
                id="inactive-focus-medium"
                state="inactive"
                placeholder="Placeholder"
                supportText="Support text"
                sizeVariant="medium"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-inactive-focus-medium"
              />
            </div>
          </section>

          {/* Inactive States Small */}
          <section>
            <Typography className="typo-text headline3_size">
              Inactive (Disabled) (Small)
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                id="inactive-default-small"
                state="inactive"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-inactive-default-small"
              />
              <ArrTextField
                id="inactive-hover-small"
                state="inactive"
                value="Input"
                placeholder="Placeholder"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-inactive-hover-small"
              />
              <ArrTextField
                id="inactive-focus-small"
                state="inactive"
                placeholder="Placeholder"
                supportText="Support text"
                sizeVariant="small"
                slotProps={{inputLabel: {shrink: false}}}
                dataTestId="text-field-inactive-focus-small"
              />
            </div>
          </section>

          <section>
            <Typography className="typo-text headline3_size">
              Password
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                label="Password"
                type="password"
                dataTestId="text-field-password"
              />
            </div>
          </section>

          <section>
            <Typography className="typo-text headline3_size">
              Payment
            </Typography>
            <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
              <ArrTextField
                type="card"
                label="Card Number"
                dataTestId="text-field-card-number"
              />
            </div>
          </section>
        </div>
      </Box>
    </Box>
  );
};

export default TextField;
